import { type Msg } from '@halo/chat-sdk-react';
import { ContextMenuTrigger } from '@halo/ui-chat-react';
import { useUserInfo } from '@/scripts/hooks';

// Message
export interface MsgMenuTriggerProps {
  message: Msg;
  children: React.ReactNode;
}

export const MsgMenuTrigger = memo(function MsgMenuTrigger({
  message,
  children,
}: MsgMenuTriggerProps) {
  const { user } = useUserInfo(message.owner_id);
  const data = useMemo(() => ({ message, user }), [message, user]);

  return (
    <ContextMenuTrigger
      data={data}
      w="fit-content"
      maxW="full"
      display="flex"
      alignItems="flex-end"
    >
      {children}
    </ContextMenuTrigger>
  );
});
